import { IDataGridElement } from "shared";
import { ComboList, IComboList, ProgramaComparador } from "../types";
import { IUserGeolocation } from "../types/user-geolocation.interface";

// ===================================================
// INTERFACES
// ===================================================

export interface IAppMenu {
    idMenu?: number;
    icon?: string;
    label: string;
    route?: string;
    children?: IAppMenu[];
}

/**
 * Modificar segun la aplicacion
 */
export interface IAppSession {
    person?: string;
    personid?: string;
    userid?: string;
    username?: string;
    lineaid?: string;
    cargoid?: number;
    ccosto?: string;
    ccontable?: string;
    defaultRol?: number;
    permisos?: any[];
}

// ===================================================
// MODELS
// ===================================================

export class AppGlobalConfigModel {
    loading: boolean = false;


    error: boolean = false;

    appConfig: { breadcrumb: any } = {
        breadcrumb: null
    };

    comparador: {
        universidades: { nombre: string, id: number }[],
        programas: ProgramaComparador[]
    } = {
            universidades: [],
            programas: [],
        };

    userGeoLocation: IUserGeolocation = null;
}

export class AppUiModel {

    hideSidebar = true;

    menu: IAppMenu[] = null;

    mobileLayout: boolean = false;

    comparadorInferior = {
        open: false,
        collapsed: false
    };

    stickyMenuElevation = true;

    // modalCambiarLocal: {
    //     comboLists: { locales: IComboList };
    //     gridLocales: IDataGridElement<any>;
    // } = {
    //         comboLists: { locales: new ComboList() },
    //         gridLocales: {
    //             loading: false,
    //             definition: {
    //                 columns: [
    //                     { label: 'Nombre del local', field: 'nombreLocal' },
    //                     { label: 'Seleccionar', field: 'tpl-opciones', template: 'tpl-opciones' }
    //                 ]
    //             },
    //             source: {
    //                 items: [{ nombreLocal: 'Local 01' }, { nombreLocal: 'Local 02' }],
    //                 page: 1,
    //                 pageSize: 10,
    //                 total: 2
    //             }
    //         }
    //     }
}

export class AppSessionModel {

    isLoggedIn = false;

    token: string = null;

    session: IAppSession = null;

    rawMenu: any[] = null;

    fromStorage: boolean = false;

    roles: any[] = [];
}

export class AppStoreModel {

    ui = new AppUiModel();

    session = new AppSessionModel();

    globalConfig = new AppGlobalConfigModel();

}

export const initialState = new AppStoreModel();